// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","focus":"Button_focus__3G4lG","lg":"Button_lg__1I1nB","disabled":"Button_disabled__1f6YP"};